interface IAverageRating {
  rating: string;
}

export const AverageRating = ({ rating }: IAverageRating) => {
  return (
    <div className="mx-1.5 md:text-sm md:leading-4.5 md:ml-2.5 md:py-0.5 float-left">{rating}</div>
  );
};
